import React from 'react'
import Head from 'next/head'
import CommonHead from '../_head'
import PrivacyPolicyPage from '../../src/pages/website/PrivacyPolicy/PrivacyPolicy'

export default () => (
  <>
    <Head>
      <title>Privacy Policy</title>
      <CommonHead />
    </Head>

    <PrivacyPolicyPage />
  </>
)
